import type { CustomSEOPage } from '@jane/bloom/types/schemas/roots/bloom/customSEO';

import { createMetaItem } from './createMetaVariables';

export function description(desc?: string) {
  if (!desc) return {};
  return {
    content: desc,
    name: 'description',
  };
}

export function getMetaDescription(
  customSEOPage: CustomSEOPage,
  metaVariables: Record<string, string>,
  defaultDescription: string
) {
  return description(
    createMetaItem(
      !!customSEOPage?.description,
      metaVariables,
      customSEOPage?.description ?? '',
      defaultDescription
    )
  );
}
